import i18n from "./../../i18n/i18nApp";
import helper from "./helperTool";

const deviceCalculation = {
    calculateNow(applicationController, busDeviceItems) {
        this.newInit()

        this.applicationController = helper.cloneItem(applicationController);
        this.busDeviceItems = helper.cloneItem(busDeviceItems);
        for(let device of this.busDeviceItems) {
            if(device.typeCategory == 1) {
                this.calculationResult.devices.ecg.amount += device.amount;
                this.calculationResult.devices.ecg.current += device.amount * device.current;
            }
            if(device.typeCategory == 2) {
                this.calculationResult.devices.sensor.amount += device.amount;
                this.calculationResult.devices.sensor.current += device.amount * device.current;
            }
            if(device.typeCategory == 3) {

                this.calculationResult.devices.input.amount += device.amount;
                this.calculationResult.devices.input.current += device.amount * device.current;
            }            
            if(device.typeCategory == 4) {
                this.calculationResult.devices.ecg.amount += device.amount;
                this.calculationResult.devices.ecg.current += device.amount * device.current;
            }
            this.calculationResult.current += device.amount * device.current;
            this.calculationResult.shortAddress += device.amount
        }
       
        this.roundResults();
        this.validateAmountDevices()
    },

    roundResults() {
        this.calculationResult.devices.ecg.current = Math.ceil(this.calculationResult.devices.ecg.current)
        this.calculationResult.devices.sensor.current = Math.ceil(this.calculationResult.devices.sensor.current);
        this.calculationResult.devices.input.current = Math.ceil(this.calculationResult.devices.input.current);
        this.calculationResult.current = Math.ceil(this.calculationResult.current);
    },
    getResult() {

        return helper.cloneItem(this.calculationResult)
    },

    addErrorMessage(message) {
        this.calculationResult.errorMessages.push(message)
    },

    addNoteMessage(message) {
        this.calculationResult.noteMessages.push(message)
    },

    validateAmountDevices() {
        if(parseFloat(this.applicationController.maxShortAddress) < this.calculationResult.shortAddress && this.applicationController.maxShortAddress != null) {
            this.addErrorMessage(i18n.global.t('resultGui.messages.tooManyShortAddresses.topic'))
            this.calculationResult.tooManyShortAddress = true
        }

        if(parseFloat(this.applicationController.maxSensors) < this.calculationResult.devices.sensor.amount ) {
            this.addErrorMessage(i18n.global.t('resultGui.messages.tooManySensors.topic'))
            this.calculationResult.tooManySensors = true
        }

        if(parseFloat(this.applicationController.maxEcg) < this.calculationResult.devices.ecg.amount && this.applicationController.maxEcg != null) {
            this.addErrorMessage(i18n.global.t('resultGui.messages.tooManyControlGears.topic'))
            this.calculationResult.tooManyControlGears = true
        }
        
        // Prüfe den maximalen Strom
        if(parseFloat(this.applicationController.daliPower) < (this.calculationResult.current)) {
            if(this.applicationController.isPowerExtendable == false) {
                this.calculationResult.tooManyCurrent = true
                this.addErrorMessage(i18n.global.t('resultGui.messages.tooHighPowerConsumption.topic'))

            } else {
                this.calculationResult.powerExtenderIsNeed = true
            }
        }
        // Prüfe den maximalen Strom bei zweiten Netzteil
        if((parseFloat(this.applicationController.daliPower) +100) < this.calculationResult.current && !this.calculationResult.tooManyCurrent) {
            this.addErrorMessage(i18n.global.t('resultGui.messages.tooHighPowerConsumption.topic'))
            this.calculationResult.tooManyCurrent = true
        }

        this.calculationResult.workload = 0;
        let daliPower = this.applicationController.daliPower;
        
        if(this.calculationResult.powerExtenderIsNeed) {
           // this.addNoteMessage(i18n.global.t('resultGui.messages.needSecondPowerSupply')+ ": " + "92846" )
            daliPower = daliPower + 100;
            this.addNoteMessage(i18n.global.t('resultGui.messages.needSecondPowerSupply'))
        }
        this.calculationResult.workload = Math.round(this.calculationResult.current/daliPower* 100)
        if(daliPower*0.8 < this.calculationResult.current) {
            this.addNoteMessage(i18n.global.t('resultGui.messages.workloadBigger80'))
            //this.addNoteMessage(i18n.global.t('Your_workload_is') + " " +  ((this.calculationResult.current/daliPower) * 100 ) + " %")
            this.overRecommendCurrent = true;
        }
    },

    newInit() {
        this.calculationResult = this.getBaseData()
    },

    getBaseData() {
        return {
            current: 0,
            shortAddress: 0,
            devices: {
                ecg: {
                    current: 0,
                    amount: 0
                },
                sensor: {
                    current: 0,
                    amount: 0
                },
                input: {
                    current: 0,
                    amount: 0
                }
            },
            mainMessage: {
                active: false,
                resultType: 'success',
                message: ""
            },
            noteMessages: [],
            errorMessages: [],
            tooManyCurrent: false,
            tooManyShortAddress: false,
            tooManyControlGears: false,
            powerExtenderIsNeed: false,
            tooManySensors: false,
            overRecommendCurrent: false,
            workload: 0.0
        }
    }
}

export default deviceCalculation